module.exports = __webpack_public_path__ + "static/assets/ea52886228e4caad4743ea02af5104fc.gif";